import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BooleanIconComponent } from './boolean-icon.component'

@NgModule({
  declarations: [BooleanIconComponent],
  imports: [CommonModule],
  exports: [BooleanIconComponent],
})
export class BooleanIconModule {}
